import { createReducer } from '@reduxjs/toolkit'
import { IBetbyState } from '../types'
import * as actions from '../actions'

const initialState: IBetbyState['data'] = {
  token: null,
}

export default createReducer(initialState, builder => {
  builder
    .addCase(actions.getBetbySportToken.success, (state, action) => {
      state.token = action.payload
    })
    .addCase(actions.clearSportToken, state => {
      state.token = null
    })
})
